// Custom global scripts
jQuery(document).ready(function ($) {
  'use strict';

  // Foundation Init
  $(document).foundation();

  // Mobile nav toggle
  $('#nav-mobile-toggle').on('click', function () {
    $('#nav-mobile').slideToggle();
  });

  // Use the map() function method to loop through an array’s items
  [...document.querySelectorAll('.menu-item a')].map(function (el) {
    if (el.innerText === 'Member Login') {
      let newSpan = document.createElement('span');
      newSpan.classList.add('fa');
      newSpan.classList.add('fa-user-circle');
      $(newSpan).prependTo(el);
    }
  });

}(jQuery));
